import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const GalleryPageSession = React.lazy(() => import('../gallery/GalleryPageSession'));
const GalleryPageHeader = React.lazy(() => import('../gallery/GalleryPageHeader'));

function GalleryPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <GalleryPageHeader />
       <GalleryPageSession />
      </Suspense>
    </div>
  );
}

export default GalleryPage;
